import {
  CheckIcon,
  DownloadIcon,
  HeartIcon,
  PlayIcon,
  SearchIcon,
  LinkIcon,
} from "@heroicons/react/outline";

export const buttonIcons = {
  check: CheckIcon,
  download: DownloadIcon,
  heart: HeartIcon,
  play: PlayIcon,
  search: SearchIcon,
  share: LinkIcon,
};
